import React from 'react';
import { withTranslation } from 'react-i18next';
import { formatNumber, formatPercentage } from './goalFormatters';

function GoalLineComponent({ goal, t }) {
    const alertClass = goal.alert_level ? `-${goal.alert_level}` : '';

    return (
        <div className="goal-line">
            <div className="goal-line__top">
                <span className="goal-line__priority">#{goal.priority}</span>
                <span className="goal-line__metric">{goal.metric_name}</span>
                {goal.item_label && (
                    <span className="goal-line__entity" title={goal.item_label}>
                        {goal.item_label}
                    </span>
                )}
            </div>
            <div className="goal-line__bottom">
                <span className="goal-line__numbers">
                    <span className="goal-line__num">
                        <small>{t('business_unit_budget_history.goal_target_label')}</small>
                        <span>{formatNumber(goal.target)}</span>
                    </span>
                    <span className="goal-line__arrow">→</span>
                    <span className="goal-line__num">
                        <small>{t('business_unit_budget_history.goal_achieved_label')}</small>
                        <strong>{formatNumber(goal.achieved)}</strong>
                    </span>
                </span>
                {goal.percentage !== null && goal.percentage !== undefined && (
                    <span className={`goal-line__pct item ${alertClass}`}>
                        {formatPercentage(goal.percentage)}
                    </span>
                )}
            </div>
        </div>
    );
}

export const GoalLine = withTranslation()(GoalLineComponent);
